const loading = (state, getters) => {
    return getters['ads/metricsLoading'];
};

export default {
    loading,
};
